/**
 * Default label provider implementation
 *
 * @ignore
 */
class DWLabelProvider {

    constructor(labels, lang) {
        this.lang = lang || 'en'
        this.labels = labels
    }

    getLabel(name) {
        let labels = this.labels[this.lang]

        if (labels && labels[name]) {
            return labels[name]
        }

        return name
    }

}

export {DWLabelProvider}
